import LocationAutocompleteInput, {
  SimpleItem,
} from './LocationAutocompleteInput';

export default LocationAutocompleteInput;
export { SimpleItem };
